import getRootPageOrigin from './getRootPageOrigin.js';
import rootPageOriginToIframeOriginMap from './deriveIframeOriginFromRootPageOrigin.json';

function deriveIframeOriginFromRootPageOrigin() {
  const rootPageOrigin = getRootPageOrigin();

  const isPhoenixSandboxOriginPattern =
    /^https:\/\/[0-9]+-sandbox\.cnbc\.com$/i;
  const isLocalhostOriginPattern =
    /^http:\/\/(zephr-)?localhost(\.cnbc\.com)?:\d{4}$/i;
  if (rootPageOrigin.match(isPhoenixSandboxOriginPattern)) {
    const iframeOrigin =
      rootPageOriginToIframeOriginMap['https://zephr-templates-stage.cnbc.com'];

    return iframeOrigin;
  } else if (rootPageOrigin.match(isLocalhostOriginPattern)) {
    return rootPageOrigin;
  }

  const iframeOrigin = rootPageOriginToIframeOriginMap[rootPageOrigin];

  return iframeOrigin;
}

export default deriveIframeOriginFromRootPageOrigin;
